import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice"
import { OtherDataPopupAdd } from "./boxPopupOptions/add"
import { OtherDataPopupEdit } from "./boxPopupOptions/edit"
import { OtherDataDTO } from "./dataService/dto"
import { addODInstance, GetOtherDataById, OtherDataDelete, resetGetOtherDataByIdStatus, resetODInstances, resetOtherDataCreationRequest, resetOtherDataDeleteStatus, resetOtherDataErrors, resetOtherDataUpdateRequest, setOtherDataIdToUpdate, setPMId, setUpdateOtherDataCommitmentStatement, setUpdateOtherDataProtocolIdEntry } from "./slice"

export default function BoxOtherData() {
    const dispatch = useAppDispatch()
    const otherDataState = useAppSelector(state => state.PMOtherData)
    const PMState = useAppSelector(state => state.personalManagement)
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [openPopupEdit, setOpenPopupEdit] = useState<boolean>(false)

    const onEditHandler = (od: OtherDataDTO) => {
        dispatch(setUpdateOtherDataProtocolIdEntry(od.protocolIdEntry))
        dispatch(setUpdateOtherDataCommitmentStatement(od.commitmentStatement))
        dispatch(setOtherDataIdToUpdate(od.id))
        setOpenPopupEdit(true)
    }

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(setPMId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId))
        }
    }, [PMState.currentPersonalManagementId])

    useEffect(() => {
        dispatch(resetODInstances())
        if (
            PMState.getByIdPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getByIdPersonalManagementResourcesResponse?.otherDataIds
        ) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse.otherDataIds.length; index++) {
                dispatch(GetOtherDataById(PMState.getByIdPersonalManagementResourcesResponse.otherDataIds[index].toString()))
            }
        }
    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (
            otherDataState.getOtherDataByIdStatus === 'successfully' &&
            otherDataState.getOtherDataByIdResponse !== undefined
        ) {
            dispatch(resetGetOtherDataByIdStatus())
            dispatch(addODInstance(otherDataState.getOtherDataByIdResponse))
        }
    }, [otherDataState.getOtherDataByIdStatus])

    useEffect(() => {
        if (otherDataState.otherDataDeleteStatus === 'successfully') {
            dispatch(resetOtherDataDeleteStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [otherDataState.otherDataDeleteStatus])

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">Documenti</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi Documenti"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Riferimento Curriculum</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {otherDataState.otherDataInstances.length === 0 ? (
                                <tr>
                                    <td colSpan={3} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessun documento trovato
                                    </td>
                                </tr>
                            ) : (
                                otherDataState.otherDataInstances.map((od, index) => (
                                    <tr
                                        key={od.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {od.protocolIdEntry}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {od.commitmentStatement}
                                        </td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandler(od)}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => dispatch(OtherDataDelete(od.id!))}
                                                >
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {openPopup && (
                <PopupForm title="Aggiungi Documenti" close={() => {
                    dispatch(resetOtherDataErrors())
                    dispatch(resetOtherDataCreationRequest())
                    setOpenPopup(false)
                }}>
                    <OtherDataPopupAdd close={() => setOpenPopup(false)} />
                </PopupForm>
            )}

            {openPopupEdit && (
                <PopupForm title="Modifica Documenti" close={() => {
                    dispatch(resetOtherDataErrors())
                    dispatch(resetOtherDataUpdateRequest())
                    setOpenPopupEdit(false)
                }}>
                    <OtherDataPopupEdit close={() => setOpenPopupEdit(false)} />
                </PopupForm>
            )}
        </div>
    )
}